module.exports = __webpack_public_path__ + "img/能源.7cd7c3f5.png";